// extracted by mini-css-extract-plugin
module.exports = {"progress":"progress-circle_progress__1WzvN","value":"progress-circle_value__3Iy9l"};